export default function TrustBand() {
  const items = [
    "The Awakened Artist Academy",
    "A quiet remembering",
    "For artists who&rsquo;ve been listening less",
    "Begin gently",
    "Reawaken your creativity",
    "Not a course. Not a system.",
  ];

  const loop = [...items, ...items];

  return (
    <section
      data-testid="trust-band"
      className="border-y border-[#E5E0D8] bg-[#F7F5F2] overflow-hidden"
      aria-label="Trust strip"
    >
      <div className="relative">
        <div className="flex w-max animate-marquee py-4 gap-12 will-change-transform">
          {loop.map((t, i) => (
            <div
              key={i}
              className="flex items-center gap-12 font-body text-[12px] uppercase tracking-[0.28em] text-[#5C5C5C] whitespace-nowrap"
            >
              <span className="h-1 w-1 rounded-full bg-[#1FA5B8]" />
              <span dangerouslySetInnerHTML={{ __html: t }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
